import React, { Fragment } from "react"
import { Link } from "react-router-dom"

const BlogFourContent = [
    {
        img: "blog-21",
        tag: "Investigación , Tecnología",
        title: "Google está eliminando la sección de Películas y TV de la Play Store",
        desc: "Desarrollar continuamente funcionalidades integradas con ancho de banda de alta calidad. Promover experiencia distintiva en lugar de tecnologías convencionales. Generar continuamente mercados nicho escalables sin portales empresariales. Paralelizar objetivamente soluciones escalables con altos estándares. Implementar plataformas verticales de manera creíble.",
        authorName: "Samir Jam",
        date: "21 Jan 2022",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock",
        btnText:"Leer Más"
    }, 
    {
        img: "blog-22",
        tag: "Investigación , Tecnología",
        title: "Anunciando la agenda completa de TC Sessions: Robótica este julio",
        desc: "Desarrollar continuamente funcionalidades integradas con ancho de banda de alta calidad. Promover experiencia distintiva en lugar de tecnologías convencionales. Generar continuamente mercados nicho escalables sin portales empresariales. Paralelizar objetivamente soluciones escalables con altos estándares. Implementar plataformas verticales de manera creíble.",
        authorName: "Anisa Kdar",
        date: "17 Sep 2020",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock",
        btnText:"Leer Más"
    }, 
    {
        img: "blog-23",
        tag: "Investigación , Tecnología",
        title: 'Los términos de los acuerdos cambian en una recesión. Esto es lo que debes tener en cuenta',
        desc: 'Desarrollar continuamente funcionalidades integradas con ancho de banda de alta calidad. Promover experiencia distintiva en lugar de tecnologías convencionales. Generar continuamente mercados nicho escalables sin portales empresariales. Paralelizar objetivamente soluciones escalables con altos estándares. Implementar plataformas verticales de manera creíble.',
        authorName: "Samir Jam",
        date: "21 Jan 2020",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock",
        btnText:"Leer Más"
    },
    {
        img: "blog-24",
        tag: "Investigación , Tecnología",
        title: "Kibo School obtiene $2M para ofrecer títulos STEM en línea a estudiantes en África",
        desc: "Desarrollar continuamente funcionalidades integradas con ancho de banda de alta calidad. Promover experiencia distintiva en lugar de tecnologías convencionales. Generar continuamente mercados nicho escalables sin portales empresariales. Paralelizar objetivamente soluciones escalables con altos estándares. Implementar plataformas verticales de manera creíble.",
        authorName: "Chris Hams",
        date: "19 Jun 2222",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock",
        btnText:"Leer Más"
    },
]

const BlogStyleFour = () => {
    return (
        <Fragment>
            {BlogFourContent.map((val, i)=>(
                <div key={i} className="blog-style-two style-four mb-lg-45 mb-275">
                <div className="blog-thumb">
                    <img className="w-100" src={`assets/img/blog/${val.img}.jpg`} alt="img"/>
                </div>
                <div className="blog-content">
                    <div className="blog-tag pb-10">
                        {val.tag}
                    </div>
                    <h3>
                        <Link className="blog-title" to="/blog-details">{val.title}</Link>
                    </h3>
                    <div className="blog-meta">
                        <a href="#" className="mr-20"><i className={val.icon1}/>
                            {val.authorName}</a>
                        <a href="#"><i className={val.icon2}/> {val.date}</a>
                    </div>
                    <p>{val.desc}</p>
                    <Link className="more-btn" to="/blog-details">{val.btnText}</Link>
                </div>
            </div>
            ))}
        </Fragment>
    )
}

export default BlogStyleFour